
























import { Component, Watch, Vue } from 'vue-property-decorator';
import { TimeRangeBucket } from '@/store/artists/types';

@Component({})
export default class TimeRange extends Vue {
    selected: TimeRangeBucket = this.$store.getters['artists/bucket'];

    @Watch('selected')
    newTimeRangeSelected(bucket: TimeRangeBucket) {
        this.$store.commit('artists/setBucket', bucket);
    }
}
